// extracted by mini-css-extract-plugin
module.exports = {"wallpaperBlock":"WallpaperPicker_wallpaperBlock__WAbTX","title":"WallpaperPicker_title__VLqCy"};